import React, { useContext } from "react";
import "./accountTermsAndCondtions.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";

const COMPANY_NAME = "ReservaSinFila";
const LAST_UPDATED = "October 14, 2025";

const renderParagraphs = (section) =>
	Object.keys(section || {})
		.filter((k) => k.startsWith("p"))
		.map((key) => (
			<p key={key}>
				{typeof section[key] === "string"
					? section[key].replace("{{COMPANY_NAME}}", COMPANY_NAME)
					: null}
			</p>
		));

const AccountTermsAndCondtions = () => {
	const { language } = useContext(CombinedContext);
	const t = translations[language].terms;

	return (
		<div className="terms-page">
			<div className="terms-container">
				{/* HEADER */}
				<header className="terms-header">
					<h1>{t.title}</h1>
					<p className="terms-updated">
						{t.lastUpdated}: {LAST_UPDATED}
					</p>
				</header>

				{/* 1) INTRO */}
				<section className="terms-section">
					<h2>{t.intro.heading}</h2>
					{renderParagraphs(t.intro)}
				</section>

				{/* 2) ELIGIBILITY */}
				<section className="terms-section">
					<h2>{t.eligibility.heading}</h2>
					<ul>
						{t.eligibility.list.map((item, i) => (
							<li key={i}>{item}</li>
						))}
					</ul>
				</section>

				{/* 3) ACCOUNTS */}
				<section className="terms-section">
					<h2>{t.accounts.heading}</h2>
					<ul>
						{t.accounts.list.map((item, i) => (
							<li key={i}>{item}</li>
						))}
					</ul>
				</section>

				{/* 4) BOOKINGS */}
				<section className="terms-section">
					<h2>{t.bookings.heading}</h2>
					{renderParagraphs(t.bookings)}
				</section>

				{/* 5) PROFESSIONAL RESPONSIBILITIES */}
				<section className="terms-section">
					<h2>{t.proResponsibilities.heading}</h2>
					<ul>
						{t.proResponsibilities.list.map((item, i) => (
							<li key={i}>{item}</li>
						))}
					</ul>
				</section>

				{/* 6) ACCEPTABLE USE */}
				<section className="terms-section">
					<h2>{t.acceptableUse.heading}</h2>
					<ul>
						{t.acceptableUse.list.map((item, i) => (
							<li key={i}>{item}</li>
						))}
					</ul>
				</section>

				{/* 7) USER CONTENT */}
				<section className="terms-section">
					<h2>{t.userContent.heading}</h2>
					{renderParagraphs(t.userContent)}
				</section>

				{/* 8) INTELLECTUAL PROPERTY */}
				<section className="terms-section">
					<h2>{t.ip.heading}</h2>
					{renderParagraphs(t.ip)}
				</section>

				{/* 9) DISCLAIMER */}
				<section className="terms-section">
					<h2>{t.disclaimer.heading}</h2>
					{renderParagraphs(t.disclaimer)}
				</section>

				{/* 10) LIABILITY */}
				<section className="terms-section">
					<h2>{t.liability.heading}</h2>
					{renderParagraphs(t.liability)}
				</section>

				{/* 11) INDEMNITY */}
				<section className="terms-section">
					<h2>{t.indemnity.heading}</h2>
					<p>{t.indemnity.text}</p>
				</section>

				{/* 12) TERMINATION */}
				<section className="terms-section">
					<h2>{t.termination.heading}</h2>
					<p>{t.termination.text}</p>
				</section>

				{/* 13) PRIVACY */}
				<section className="terms-section">
					<h2>{t.privacy.heading}</h2>
					<p>{t.privacy.text}</p>
				</section>

				{/* 14) GOVERNING LAW */}
				<section className="terms-section">
					<h2>{t.law.heading}</h2>
					<p>{t.law.text}</p>
				</section>

				{/* 15) CHANGES */}
				<section className="terms-section">
					<h2>{t.changes.heading}</h2>
					<p>{t.changes.text}</p>
				</section>

				{/* 16) MISC */}
				<section className="terms-section">
					<h2>{t.misc.heading}</h2>
					<ul>
						{t.misc.list.map((item, i) => (
							<li key={i}>{item}</li>
						))}
					</ul>
				</section>
			</div>
		</div>
	);
};

export default AccountTermsAndCondtions;
